import { FetchStatus, PageMode } from "../base/types";
import { IPage, IPageView } from "../design/page/models";
import { PageContextProvider, PageDataContextProvider } from "../design/page/context";
import { createContext, useContext, useEffect } from "react";

import { useAuth } from "../../modules/auth";
import { useGetDashboardPage } from "./useGetDashboardPage";
import { useParams } from "react-router-dom";

interface IDashboardPageContext {
    status: FetchStatus
    error?: string
    page?: IPage
}

const context = createContext<IDashboardPageContext>({
    status: FetchStatus.Idle
})

export const DashboardPageProvider = ({ children }: {
    children?: React.ReactNode
}) => {
    const { user } = useAuth()
    const { siteId } = useParams()

    const [getDashboardPage, { result: page, status, error }] = useGetDashboardPage();

    useEffect(() => {
        if (!user || !siteId)
            return;
        
        getDashboardPage(siteId, user)

        // eslint-disable-next-line
    }, [siteId, user])

    if (!page || !siteId) {
        return <>{children}</>
    }

    const pageView: IPageView = { pageMode: PageMode.View }
    return (
        <PageContextProvider page={page} pageView={pageView}>
            <PageDataContextProvider page={page} pageView={pageView}>
                <context.Provider value={{ status, error, page }}>
                    {children}
                </context.Provider>
            </PageDataContextProvider>
        </PageContextProvider>)
}

export function useDashboardPage() {
    return useContext(context)
}